// extracted by mini-css-extract-plugin
module.exports =  {"tc-icon-toggle":"ActionIconToggle-module__tc-icon-toggle___PTdQD","active":"ActionIconToggle-module__active___TSTg3","tick":"ActionIconToggle-module__tick___C9U69"};